/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PredictiveAnswerDto } from './PredictiveAnswerDto';
export type PredictiveProductAnswerDto = {
    target: PredictiveProductAnswerDto.target;
    answer: PredictiveAnswerDto;
};
export namespace PredictiveProductAnswerDto {
    export enum target {
        DESCRIPTION = 'DESCRIPTION',
        USPS = 'USPS',
        FEATURES_SERVICES = 'FEATURES_SERVICES',
        COMPETING_TOOLS = 'COMPETING_TOOLS',
    }
}

